export default "__VITE_ASSET__CHkfGjLW__"